import { createFileRoute } from '@tanstack/react-router';
import { ProcessorRateSettingsPage } from '@/components/finance/onboarding';

// FPD-052 — settings page for editing processor fee rates post-onboarding.
// Under the Settings sub-nav alongside setup / sources / bank-accounts.
export const Route = createFileRoute('/admin/finance/settings/processors')({
  component: ProcessorRateSettingsPage,
});
